export enum PlanType {
    Free = 0,
    FamiliesAnnually = 1,
    TeamsMonthly = 2,
    TeamsAnnually = 3,
    EnterpriseMonthly = 4,
    EnterpriseAnnually = 5,
    Custom = 6,
}
